import classnames from 'classnames'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { getOpacityColor } from 'embed/utils'
import { css } from 'emotion'
import * as React from 'react'

const Lock = require('assets/components/lock.svg')
const styles = require('./styles')

export const DisclaimerBox: React.SFC = () => (
  <ThemeConsumer>
    {({ colorSecondary }) => (
      <div className={styles.container} style={{ backgroundColor: getOpacityColor(colorSecondary, 5) }}>
        <div
          className={classnames(
            styles.iconWrapper,
            css`
              svg path {
                fill: ${colorSecondary} !important;
              }
            `,
          )}
        >
          <Lock />
        </div>
        <div className={styles.textWrapper}>
          <h4>We will never share your information.</h4>
          <p>
            Only LeapLife or the carrier you apply with will use this information to reach out to you about your
            application request.
          </p>
        </div>
      </div>
    )}
  </ThemeConsumer>
)
